import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Select,
  FormControl,
  MenuItem,
  Typography,
  TextField,
  Paper,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import React from "react";
import { formatCurrency, formatDate } from "../../../utils/utils";
import {
  deletedTableHeaderStyles,
  deletedTableRowStyles,
} from "../../../utils/styles";

const headerStyles = {
  fontSize: "0.55rem",
  fontWeight: 600,
};

const DeletedPayments = ({
  deletedPaymentDetails,
}: {
  deletedPaymentDetails: any;
}) => {
  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow style={deletedTableRowStyles}>
            <TableCell style={deletedTableHeaderStyles}>Date</TableCell>
            <TableCell style={deletedTableHeaderStyles}>Mode</TableCell>
            <TableCell style={deletedTableHeaderStyles}>Amount</TableCell>
            <TableCell style={deletedTableHeaderStyles}>Location</TableCell>
            <TableCell style={deletedTableHeaderStyles}>Updated On</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {deletedPaymentDetails && deletedPaymentDetails?.length > 0 ? (
            deletedPaymentDetails?.map((payment: any, idx: number) => {
              return (
                <TableRow key={idx} style={deletedTableRowStyles}>
                  <TableCell style={deletedTableHeaderStyles}>
                    {formatDate(payment?.paymentDate || payment?.date)}
                  </TableCell>
                  <TableCell style={deletedTableHeaderStyles}>
                    {payment?.paymentMode || payment?.mode}
                  </TableCell>
                  <TableCell style={deletedTableHeaderStyles}>
                    {formatCurrency(payment?.paymentAmount || payment?.amount)}
                  </TableCell>
                  <TableCell style={deletedTableHeaderStyles}>
                    {payment?.paymentLocation || payment?.location || "-"}
                  </TableCell>
                  <TableCell style={deletedTableHeaderStyles}>
                    {formatDate(payment?.updatedAt || payment?.createdOn)}
                  </TableCell>
                </TableRow>
              );
            })
          ) : (
            <TableRow>
              <TableCell colSpan={7} align="center">
                No payment details available.
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default DeletedPayments;
